import { CountryVm } from '../api';
import { Civility } from '../shared/models/model/concretes/shared/civility.model';
import { ConsentState, initialConsentState } from './consent.store';
import { initialPhonePrefixState, PhonePrefixState } from './phone-prefix.store';

export type SubscriberState = {
  email: string;
  civility: Civility | null;
  lastname: string;
  firstname: string;
  birth_date: string | Date | null;
  birth_postal_code: string | null;
  birth_city: string;
  birth_country: CountryVm | null;
  nationality: CountryVm | null;
  phone_prefix: PhonePrefixState;
    consent: ConsentState
  is_client: boolean;
  from_context: boolean;
};

export const initialSubscriberState: SubscriberState = {
  email: '',
  civility: null,
  lastname: '',
  firstname: '',
  birth_date: '',
  birth_postal_code: '',
  birth_city: '',
  birth_country: {
    countryCode: 'FR',
    countryNameFr: 'France'
  },
  nationality: {
    countryCode: 'FR',
    countryNameFr: 'France'
  },
  phone_prefix: initialPhonePrefixState,
  consent: initialConsentState,
  is_client: false,
  from_context: false
};
